import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Inject
} from "@angular/core";
import { Router } from "@angular/router";
import { CoreLogService } from "../../services/log.service";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";
import { AccessibilityWebShopService } from "../../services/accessibilityWebShop.service";

@Component({
  selector: "ya-accessibilty-dialog",
  templateUrl: "./accessibiltyDialog.component.html",
  styleUrls: ["./accessibiltyDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessibiltyDialogComponent implements OnInit {
  public accessabiltyfontsize: boolean = false;
  public accessabiltycolors: boolean = false;
  public accessabiltynoimages: boolean = false;
  public accessabiltyreducedmotion: boolean = false;

  constructor(
    public bottomSheetRef: MatBottomSheetRef<AccessibiltyDialogComponent, boolean>,
    private _coreLanguageService: CoreLanguageService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _router: Router,
    public _accessibilityWebShopService: AccessibilityWebShopService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {
    this.accessabiltyfontsize = this._accessibilityWebShopService.isAccessabiltyFontSizeEnabled();
    this.accessabiltycolors = this._accessibilityWebShopService.isAccessabiltyColorsEnabled();
    this.accessabiltynoimages = this._accessibilityWebShopService.isNoImagesModeEnabled();
    this.accessabiltyreducedmotion = this._accessibilityWebShopService.isReducedMotionModeEnabled();
  }

  ngOnInit(): void {
  }

  private pushChanges(): void {
    try {
      if (!this._changeDetectorRef['destroyed']) {
        this._changeDetectorRef.detectChanges();
      }
    } catch (e) {
      this._coreLogService.error("AccessibiltyDialogComponent.pushChanges", "Change detection failed", e);
    }
  }

  public toggleAccessabiltyFontSize(): void {
    this.accessabiltyfontsize = !this.accessabiltyfontsize;
    this.pushChanges();
  }

  public toggleAccessabiltyColors(): void {
    this.accessabiltycolors = !this.accessabiltycolors;
    this.pushChanges();
  }
  public toggleNoImagesMode(): void {
    this.accessabiltynoimages = !this.accessabiltynoimages;
    this.pushChanges();
  }

  public toggleReducedMotionMode(): void {
    this.accessabiltyreducedmotion = !this.accessabiltyreducedmotion;
    this.pushChanges();
  }
  public get canConfirmSelection(): boolean {
    return this.accessabiltyfontsize || this.accessabiltycolors || this.accessabiltynoimages || this.accessabiltyreducedmotion;
  }

  public get isAccessibilityModeActive(): boolean {
    return this._accessibilityWebShopService.getAccessibilityModeActive();
  }

  public resetChanges(): void {
    this.accessabiltyfontsize = false;
    this.accessabiltycolors = false;
    this.accessabiltyreducedmotion = false;
    this.accessabiltynoimages = false;
    this._accessibilityWebShopService.setAccessibilityModes(false, false, false, false);
    this.bottomSheetRef.dismiss();
  }

  public confirmSelection(): void {
    this._accessibilityWebShopService.setAccessibilityModes(
      this.accessabiltyfontsize,
      this.accessabiltycolors,
      this.accessabiltynoimages,
      this.accessabiltyreducedmotion
    );
    this.bottomSheetRef.dismiss();
  }

  public evaluateLanguageString(s: string | (() => string) | boolean): string {
    if (typeof s === "string") {
      return this._coreLanguageService.value(s);
    } else if (typeof s === "function") {
      return s();
    }
    return '';
  }

  public closeBottomSheet(): void {
    this.bottomSheetRef.dismiss(true);
  }

  public navigateToAccessibilityTerm(): void {
    this.bottomSheetRef.dismiss();
    this._router.navigate(["/termcondition", -2]);
  }
}
